// File: src/components/common/GradeLevelDisplay.js
// -----------------------------------------------------
import React from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Grade level display component
 */
const CardMeta = ({ icon, info, ...props }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      mt: 'auto',
      mb: 1,
      ...props.sx
    }}
    {...props}
  >
    {icon}
    <Typography 
      variant="caption" 
      color="text.secondary" 
      fontWeight="medium"
    >
      {info}
    </Typography>
  </Box>
);

CardMeta.propTypes = {
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.node,
  sx: PropTypes.object
};

export default CardMeta;